import ApiService, { RequestOptions } from 'cio/services/api';
import config from 'cio/config/environment';

// Override the API Service to prevent it from sending any API requests - except
// for anonymous analytics tracking events
export default class DemoApiService extends ApiService {
  request<Data = any>(path: string, options: RequestOptions = {}): Promise<Data> {
    if (path === 'track_anon') {
      return super.request(path, options);
    }

    if (!config.isProduction) {
      /* eslint-disable no-console */
      console.log('API service request called:');
      console.log(path, options);
      /* eslint-enable no-console */
    }

    return Promise.resolve(undefined as any);
  }
}
